import { ApolloProvider } from '@apollo/client'
import { AlertContext, defaultAlertStore } from 'components/alert'
import { BreadcrumbContext, defaultBreadcrumbStore } from 'components/breadcrumb'
import { handleError, PromiseErrorBoundary } from 'components/error'
import { defaultEsusViewStore, EsusViewContext } from 'components/esus/EsusViewContext'
import { TourProvider } from 'components/tour/components/TourContext'
import { FlagsProvider } from 'config/useFlagsContext'
import apolloClient from 'graphql/client'
import { ConfiguracoesProvider } from 'hooks/configuracoes'
import { InitialView } from 'view/InitialView'

export const PecApp = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <TourProvider>
        <PromiseErrorBoundary onError={(error) => handleError({ error, suppressValidationError: true })}>
          <AlertContext.Provider value={defaultAlertStore}>
            <BreadcrumbContext.Provider value={defaultBreadcrumbStore}>
              <EsusViewContext.Provider value={defaultEsusViewStore}>
                <ConfiguracoesProvider>
                  <FlagsProvider>
                    <InitialView />
                  </FlagsProvider>
                </ConfiguracoesProvider>
              </EsusViewContext.Provider>
            </BreadcrumbContext.Provider>
          </AlertContext.Provider>
        </PromiseErrorBoundary>
      </TourProvider>
    </ApolloProvider>
  )
}
